var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog-dashboard-title"},[_c('div',[_c('Icon',{attrs:{"name":_vm.icon}})],1),(_vm.badgeTitle)?_c('div',[_c('KpiBadge',{attrs:{"showBadgeIcon":false,"text":_vm.badgeTitle,"type":_vm.badgeType}})],1):_vm._e(),_c('div',[_c('span',{staticClass:"catalog-dashboard-title-text"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }